export default __webpack_public_path__ + "static/media/Arithmetic_Genius_Contest_Mobile_BG.1130c03c.jpg";